'use client';

import { useTranslations } from 'next-intl';

import { formattedPrice } from '@/ui-kit/price';

import { GiftCardPayButtons } from '../GiftCardPayButtons/GiftCardPayButtons';
import { styles } from './CardParamsPreviewFixed.styles';

export interface CardParamsPreviewFixedProps {
  quantity: number;
  nominal: number;
  isPayButtonDisabled?: boolean;
}

export function CardParamsPreviewFixed({
  quantity,
  nominal,
  isPayButtonDisabled
}: CardParamsPreviewFixedProps) {
  const slots = styles();
  const t = useTranslations();

  return (
    <div className={slots.base()}>
      <div className={slots.header()}>
        <div className={slots.content()}>
          <span className={slots.productCount()}>
            {t('productCount', { count: quantity })}
          </span>
          <span className={slots.total()}>{formattedPrice(nominal * quantity)}</span>
        </div>
      </div>
      <GiftCardPayButtons
        className={slots.payButtons()}
        disabled={isPayButtonDisabled}
        loading={isPayButtonDisabled}
      />
    </div>
  );
}
